import axios, { resHandle } from "@/plugins/axios";


/**
 * @description 临床数据中心：平台概览
 * @param vCom Vue组件
 */
const CdrGailan = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/stats/all", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床数据中心：机构量表月采集趋势图
 * @param vCom Vue组件
 */
const CdrJigouYuecaiji = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/stats/month", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床数据中心：各机构量表采集数分布状况
 * @param vCom Vue组件
 */
const CdrJigouLiangbiao = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/stats/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床数据中心：各病历量表采集状况统计
 * @param vCom Vue组件
 */
const CdrBingliliangbiao = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/stats/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 临床数据中心：人口统计：总体情况/年龄分布/性别分布
 * @description 疾病诊断分布：西医疾病、中医疾病、中医证型、中医体质
 * @param vCom Vue组件
 */
const CdrRenkou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/stats/population", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 影像中心：采集数：平台概览
 * @param vCom Vue组件
 */
const IdrGailan = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/stats/all", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 影像中心：机构影像数据月采集趋势图
 * @param vCom Vue组件
 */
const IdrJigouYuecaiji = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/stats/month", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 影像中心：各机构影像数据采集数分布状况
 * @param vCom Vue组件
 */
const IdrJigou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/stats/hospital", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 影像中心：各影像数据采集状况统计
 * @param vCom Vue组件
 */
const IdrYingxiang = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/stats/cate", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 影像中心：舌图统计: 舌图疾病分布
 * @param vCom Vue组件
 */
const IdrShetuJibing = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/tongue/stats", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 影像中心：舌图对应疾病的关系:舌色、舌形、苔色、苔质，各证型分布
 * @param vCom Vue组件
 */
const IdrShetuGuanxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/tongue/relation", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 影像中心：舌图对应疾病的关系: 舌图特征分析、舌图特征关联规则
 * @param vCom Vue组件
 */
const IdrShetuFenxiGuize = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/image/tongue/rule", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 治未病中心：大屏看板：实时数据滚动
 * @param vCom Vue组件
 */
const GetDapinData = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/stats/realtime", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};




export {
    CdrGailan, CdrJigouYuecaiji, CdrJigouLiangbiao, CdrBingliliangbiao, CdrRenkou,
    IdrGailan, IdrJigouYuecaiji, IdrJigou, IdrYingxiang, IdrShetuJibing, IdrShetuGuanxi, IdrShetuFenxiGuize,
    GetDapinData
};

